/**
 * Reexporta o ambiente gerado por scripts/load-env.js.
 * Rode antes do build/serve: node scripts/load-env.js <local|development|staging|production>
 */
import { environment as generated } from './environment.generated';
export const environment = generated;
export type Environment = typeof generated;
